import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
// import { useEffect } from "react";

const RequireAuth = ({ allowedPer }) => {
  const location = useLocation();
  const { permissions, user } = useSelector((x) => x.auth);

  // useEffect(() => {
  //   console.log(allowedPer);
  //   console.log(permissions?.includes(allowedPer));
  // }, []);

  return permissions?.includes(allowedPer) ? (
    <Outlet />
  ) : user ? (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireAuth;
